import {
  drybulkCargoOperationsService,
  type FinalDraftSurveyRequest,
} from "@services/drybulkCargoOperationsApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";
import { closeOutContext } from "./closeOutTransaction";

export const useFinalDraftSurvey = (operationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: FinalDraftSurveyRequest) =>
      runTransaction(closeOutContext("enter_final_draft_survey", operationId), (transactionId) =>
        drybulkCargoOperationsService.enterFinalDraftSurvey(operationId, request, {
          transactionId,
        }),
      ),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.detail(operationId),
        }),
        queryClient.invalidateQueries({ queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.searchAll() }),
      ]),
  });
};
